/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Case_Payment_Plan_InvalidInputs */

const en_api_error_case_payment_plan_invalid = /** @type {(inputs: Api_Error_Case_Payment_Plan_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The payment plan is not valid for the current client policy or confirmed payments.`)
};

const pt_br2_api_error_case_payment_plan_invalid = /** @type {(inputs: Api_Error_Case_Payment_Plan_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O plano de pagamento não é válido para a política atual do cliente ou para os pagamentos confirmados.`)
};

/**
* | output |
* | --- |
* | "The payment plan is not valid for the current client policy or confirmed payments." |
*
* @param {Api_Error_Case_Payment_Plan_InvalidInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_case_payment_plan_invalid = /** @type {((inputs?: Api_Error_Case_Payment_Plan_InvalidInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Case_Payment_Plan_InvalidInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_case_payment_plan_invalid(inputs)
	return pt_br2_api_error_case_payment_plan_invalid(inputs)
});